/**
 * JSN Name Display Utilities
 *
 * Public display format: First Name + Last Initial (e.g. "Mary W.")
 * Admin display: Full first + last name
 */

/**
 * Format a public display name from first and last name.
 * Returns "FirstName L." format.
 */
export function formatPublicName(firstName: string | null | undefined, lastName: string | null | undefined): string {
  const first = (firstName || '').trim();
  const last = (lastName || '').trim();

  if (!first) return 'Member';

  if (last) {
    return `${first} ${last.charAt(0).toUpperCase()}.`;
  }

  return first;
}

/**
 * Fallback: parse a legacy displayName string into public format.
 * "Mary Wambui" → "Mary W." *"Mary" → "Mary"
 */
export function parseDisplayNameToPublic(displayName: string | null | undefined): string {
  if (!displayName || !displayName.trim()) return 'Member';

  const parts = displayName.trim().split(/\s+/);
  const first = parts[0] || '';
  const second = parts[1] || '';

  if (!first) return 'Member';

  if (second) {
    return `${first} ${second.charAt(0).toUpperCase()}.`;
  }

  return first;
}

/**
 * Get the public display name for a profile.
 * Prefers first_name + last_name fields; falls back to parsing displayName.
 */
export function getPublicDisplayName(profile: {
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
}): string {
  if (profile.firstName && profile.firstName.trim()) {
    return formatPublicName(profile.firstName, profile.lastName);
  }
  return parseDisplayNameToPublic(profile.displayName);
}
